<div class="p8-bdc_categories-list__container">
  <div *ngFor="let category of getMainCategories()" class="p8-bdc_categories-list__category">
    <div class="p8-bdc_categories-list__link mat-display-1"
         [routerLink]="['/page/', category.id]">
      <mat-icon class="">{{(category.data.icon) ? category.data.icon : 'account_balance'}}</mat-icon> {{ category.data.title }}
    </div>
    <div class="p8-bdc_categories-list__detail-container" fxLayout="row wrap">
      <p8-bdc-categories-detail *ngFor="let subcategory of getSubCategories(category.children)"
                             [category]="subcategory"
                             fxFlex="33.33%"
                             fxFlex.sm="50%"
                             fxFlex.xs="100%"
      ></p8-bdc-categories-detail>
    </div>
  </div>
</div>


